import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';

export const MODEL_NAME = 'starterListCard';

/**
 * Reusable card component for individual starter list items
 */
export const StarterListCard = ({ title, image, onClick }) => {
  return (
    <div onClick={onClick} role="presentation" className="sui-h-full">
      <Card
        role="button"
        PaperProps={{ className: 'sui-h-full' }}
        aria-label={`Select ${title} starter list`}
        data-testid="starter-list-card"
      >
        <CardBody>
          {/* Image */}
          <div className="sui-mb-3 sui-flex sui-justify-center">
            <img
              src={image}
              alt={title}
              width="100%"
              height="100%"
              className="sui-w-full sui-h-24 sui-object-cover sui-rounded"
            />
          </div>

          {/* Title */}
          <Typography variant="h6" weight="bold" align="center">
            {title}
          </Typography>
        </CardBody>
      </Card>
    </div>
  );
};

StarterListCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

StarterListCard.displayName = 'StarterListCard';

export default StarterListCard;
